'use strict';

/*

    CanadaPostAutocomplete
    
        Contains code to initialize Canada Post Autocomplete
        and bind autocomplete functionality  to form fields in pug. 

        Also contains 
            - Reusable code (helper method) to clear validation errors for form fields.
            - Postal code character checking object to ensure entered 
              postal code is in-fact from selected province by comparing first char. 

    Param form: 
        The form element wrapping the address search / fields you want to bind
        CanadaPostAutocomplete to.


*/

function CanadaPostAutocomplete(form) {
  var fields = [
  /*  
    Binds Canada Post auto-complete functionality to our fields: 
      'element' key corresponds to the name attr of the filed in the pug
      'field' key corresponds to its corresponding canada post field name
  */

  // search field
  { element: 'address', field: 'address', mode: pca.fieldMode.SEARCH },
  // populate fields
  { element: 'street_number', field: 'BuildingNumber', mode: pca.fieldMode.POPULATE }, { element: 'street_name', field: 'Street', mode: pca.fieldMode.POPULATE }, { element: 'apartment', field: 'SubBuilding', mode: pca.fieldMode.POPULATE }, { element: 'city', field: 'City', mode: pca.fieldMode.POPULATE }, { element: 'state_province', field: 'ProvinceName', mode: pca.fieldMode.POPULATE }, { element: 'po_box', field: 'POBoxNumber', mode: pca.fieldMode.POPULATE }, { element: 'postal_zip_code', field: 'PostalCode', mode: pca.fieldMode.POPULATE }, { element: 'country', field: 'CountryName', mode: pca.fieldMode.POPULATE }];

  var options = {
    key: 'zg44-xp75-cn78-re32',
    suppressAutocomplete: true,
    showCountry: false,
    culture: 'en-ca',
    languagePreference: 'eng'
  };

  //  Initialize Canada Post, bind to control key
  this.control = new pca.Address(fields, options);

  //  Helper Method
  this.resetFormValidations = function () {
    var mogoForm = form.mogo();
    // `resetValidationField` only exists once the form has been decorated with
    // SchemaValidation. On some entry paths (e.g. the manual "enter address"
    // toggle before validation is wired up) it is undefined and calling it
    // throws an uncaught TypeError that breaks the rest of the handler.
    if (typeof mogoForm.resetValidationField !== 'function') return;
    mogoForm.resetValidationField('address');
    mogoForm.resetValidationField('street_number');
    mogoForm.resetValidationField('street_name');
    mogoForm.resetValidationField('city');
    mogoForm.resetValidationField('apartment');
    mogoForm.resetValidationField('state_province');
    mogoForm.resetValidationField('postal_zip_code');
    mogoForm.resetValidationField('country');
  };

  /*
      Helper Object 
  
      This list ensures postal code 
      entered by user is correct for their selected province. 
      
      For every province listed via key 'name'
      The postal code entered by user must begin with corresponding key 'firstLetter'
      For it to be considered valid.
  
      See: https://mogofintech.atlassian.net/browse/ACCT-752
    */
  this.postalCodeMap = {
    AB: { name: 'Alberta', firstLetter: ['T'] },
    BC: { name: 'British Columbia', firstLetter: ['V'] },
    MB: { name: 'Manitoba', firstLetter: ['R'] },
    NB: { name: 'New Brunswick', firstLetter: ['E'] },
    NL: { name: 'Newfoundland & Labrador', firstLetter: ['A'] },
    NS: { name: 'Nova Scotia', firstLetter: ['B'] },
    NT: { name: 'Northwest Territories', firstLetter: ['X'] },
    NU: { name: 'Nunavut', firstLetter: ['X'] },
    ON: { name: 'Ontario', firstLetter: ['K', 'L', 'M', 'N', 'P'] },
    PE: { name: 'Prince Edward Island', firstLetter: ['C'] },
    QC: { name: 'Quebec', firstLetter: ['G', 'H', 'J'] },
    SK: { name: 'Saskatchewan', firstLetter: ['S'] },
    YT: { name: 'Yukon', firstLetter: ['Y'] }
  };
}